import store from '@/stores/map/map-store';
import { Station } from '@/stores/station/station-model';

import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';

@Module({ dynamic: true, namespaced: true, name: 'MapModule', store })
class MapModule extends VuexModule {
  private _previouslySelectedStations: Station[] = [];
  private _markedStations: Station[] = [];

  public get markedStations(): Station[] {
    return this._markedStations;
  }

  public get previouslySelectedStations(): Station[] {
    return this._previouslySelectedStations;
  }

  public get markedStationsIds(): Set<string> {
    return new Set<string>(this.markedStations.map((station) => station.id));
  }

  @Mutation
  updateMarkedStations(stations: Station[]): void {
    this._markedStations = stations;
  }

  @Mutation
  updatePreviouslySelectedStations(stations: Station[]): void {
    this._previouslySelectedStations = stations;
  }

  @Action({ commit: 'updateMarkedStations' })
  setMarkedStations(stations: Station[]): Station[] {
    return stations;
  }

  @Action({ commit: 'updatePreviouslySelectedStations' })
  setPreviouslySelectedStations(stations: Station[]): Station[] {
    return stations;
  }
}

export default getModule(MapModule);
